import React, { useReducer, useContext, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { getAuthToken } from "../api/api";
import {
  getAPIUrl,
  notify,
} from "../components/common/helpers";
import "../styles/ConfirmModal.css";
import {ReleaseContext} from "../pages/ReleaseManagement.js";
const formReducer = (state, action) => {
  switch (action.type) {
    case "RESET_FORM":
      return initialState;
    case "REASON_DATA":
      return {
        ...state,
        reason: action.reason,
      }
    case "TABLE_DATA":
      return {
        ...state,
        tableData: action.tableData,
      }
    default:
      return state;
  }
};
const initialState = {
  error: "",
  reason: {},
  tableData: {}
};

const RejectionDisplayModal = (props) => {
  const [state, dispatch] = useReducer(formReducer, initialState);
  const controller = new AbortController();

  const {
    reason,
    tableData,
  } = state;
  
  const handleClose = () => {
    setReadOnly(false);
    dispatch({ type: "RESET_FORM" });
  };

  const { moreReleaseInfo, gridEntries, readOnly, setReadOnly } = useContext(ReleaseContext);

  const requiredKeys = {
    "release_id": "Release Id",
    "file_name": "Firmware Name",
    "created_date": "Created Date", 
    "created_by": "Created By",
    "approval_state": gridEntries.approval_state,
    "approvedOrRejectedBy": gridEntries.approval_state + " By",
    "approvedOrRejectedDate": gridEntries.approval_state + " Date"
    };

    const replacements = {
      'approvedOrRejectedBy': gridEntries.approval_state + " By",
      'approvedOrRejectedDate': gridEntries.approval_state + " Date"
    }

    const hideDisplayParameters = (parameter) => {
      return parameter !== null && 
             parameter !== "Pending" &&  
             parameter !== "pending" && 
             parameter !== "approved" && parameter !== "Approved" &&
             parameter !== "rejected" && parameter !== "Rejected"
    }
        
  useEffect(() => {
    if (gridEntries && !moreReleaseInfo) {
      axios({
        method: "GET",
        url: getAPIUrl("getReleaseRejectionReason") + `?release_detail_Id=${gridEntries.release_details_id}`,
        headers: { Authorization: getAuthToken() },
        signal: controller.signal,
      })
      .then((res) => {
        if (res) {
          dispatch({ type: "REASON_DATA", reason: res.data[0]});
        }
      })
      .catch((error) => {
        error.message !== "canceled" && notify("fetching");
      });
    } else if(gridEntries && moreReleaseInfo) {
      const filteredDate = Object.fromEntries(
        Object.entries(gridEntries)
        .filter(([key]) => requiredKeys.hasOwnProperty(key))
        .map(([key, value]) => 
          replacements[key] ? [replacements[key], value] : [key, value]
      )
    )
      dispatch({ type: "TABLE_DATA", tableData: filteredDate });
    }

    return () => {
      controller.abort();
    };
  }, [gridEntries, moreReleaseInfo]);

  let displayReleaseInformation =
    Object.entries(tableData).sort(([key1], [key2]) => 
      key2.localeCompare(key1))
      .map(([key, value]) => (
          <div style={{ color: "white" }} key={key}>
          { 
          (hideDisplayParameters(value)) &&
          <>
          {(replacements["approvedOrRejectedBy"] === key || replacements["approvedOrRejectedDate"] === key) ?
          <>
          <strong>{key.charAt(0).toUpperCase() + key.slice(1)} : </strong>
          <span>{value}</span></>
            :
            <>
          <strong>{requiredKeys[key]} : </strong> 
          <span>{value}</span>
            </>
        }  
        </>
          }
          </div>
        ))

  return (
      <Modal
        show={readOnly}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
          <Modal.Header className="cancelButton">
          <Modal.Title style={{ color: "#ffffff" }}>
            <Row>
            <Col sm={{ span: 12 }}>
            {!moreReleaseInfo ? "Reason for Rejection" : `Release Details of Firmware Version - ${gridEntries.firmware_version} and Site - ${gridEntries.building_name}`}
            </Col>
            </Row>
          </Modal.Title>
          </Modal.Header>
        <Modal.Body style={{ background: "#212529" }}>
           <>
           {moreReleaseInfo  ?
           <Row className="mb-3">
           <Col sm={12}>  
           {displayReleaseInformation}
           </Col>
         </Row> : <Row className="mb-3">
            <Col sm={12}>
            <div style={{ color: "white" }}>
              <p><span>{(reason.reject_reason !== null) ? reason.reject_reason : "No Data Available"}</span></p>
            </div>
            </Col>
          </Row>
          }
        <div className="py-2"></div>
          <Row className="mb-3">
            <Col sm={{ span: 8, offset: 4 }}>
            <Button
                  className="col-md-5"
                  size="sm"
                  variant="secondary"
                  onClick={handleClose}
                >
                  OK
              </Button>
            </Col>
          </Row>
          </>
        </Modal.Body>
      </Modal>
  );
};

export default RejectionDisplayModal;
